import { rgba } from 'polished'

/**
 * Takes an array of 4 float values ranging from 0 to 1
 * Converts the float values to rgba values [0 - 255, 0 - 255, 0 - 255, 0 - 1]
 * Outputs a formatted CSS string of the color values or null
 * @param {Array<Number>} floats
 */
const floatsToCSSRGBAString = (colorArray?: any[]) => {
  const validArray = (colorArray || []).every(item => Number(item) === item)

  if (!colorArray || !validArray || colorArray.length !== 4) {
    return null
  }

  const [red, green, blue] = colorArray.map(color => Math.floor(color * 255))
  const opacity = colorArray[3]

  return rgba(red, green, blue, opacity)
}

export default floatsToCSSRGBAString
